import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import App from '@/App.vue';

import router from '@/router';
import store from '@/store';
import { axios } from '@/plugins/http-axios';
import { AxiosStatic } from 'axios';
import { plugin } from '@ifr/form-questionnaire';
import VueExcelViewer from '@uublue/vue-excel-viewer';
import '@uublue/vue-excel-viewer/lib/vue-excel-viewer.css';
import moment from 'moment';
import polyfills from '@/plugins/polyfills';
import { createPinia, PiniaVuePlugin } from 'pinia';
import { useErrorStore } from '@/pinia/helpers';

declare module 'vue/types/vue' {
  interface Vue {
    $axios: AxiosStatic;
  }
}

getMarketingGTM();
getMarketingYandex()

Vue.use(plugin);
Vue.use(VueExcelViewer);
Vue.use(PiniaVuePlugin);


import { getMarketingGTM, getMarketingYandex } from '@/plugins/marketing';
if (process.env.NODE_ENV === 'production') {
  getMarketingGTM();
  getMarketingYandex();
}

moment.locale('ru');

export const pinia = createPinia();

Vue.prototype.$moment = moment;
Vue.prototype.$axios = axios;
Vue.prototype.$vuetify = vuetify;

Vue.config.productionTip = false;

if (process.env.NODE_ENV === 'production') {
  Vue.config.errorHandler = function (e, vm, info) {
    const errorStore = useErrorStore(pinia);
    e.name = info + ' ' + e.name;

    //@ts-ignore
    errorStore.setError(e)
  };
}

Vue.config.warnHandler = function (msg, vm, trace) {
  const errorStore = useErrorStore(pinia);
  //@ts-ignore
  errorStore.setError(new Error(msg))
  console.error(msg + trace);
};

new Vue({
  pinia,
  vuetify,
  router,
  store,
  render: (h) => h(App),
  beforeCreate() {
    polyfills();
    this.$axios.interceptors.response.use(
      (resp) => {
        return resp;
      },
      (err) => {
        if (
          err?.response?.status === 403 &&
          this.$store.getters.authorized === 'authorized' &&
          !/user$/.test(err.request.responseURL)
        ) {
          if (this.$store.getters.loader.show) {
            this.$store.dispatch('setLoader');
          }

          this.$store.commit('setSession');
        } else if (err?.response?.status === 429) {
          this.$store.commit('setDDos', {
            dDos: true,
            textSeconds: err?.response.headers['x-rate-limit-retry-after-seconds'] || 0,
          });
        }

        return Promise.reject(err);
      },
    );
  },
}).$mount('#app');
